import { Component, OnInit } from '@angular/core';

import { IThesisReportSummary, IThesisReportSummaryDoctor } from '../../models/ThesisReport';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableColumn } from '../../shared/table/table.component';
import { AppService } from '../../services/app.service';
import { ThesisReportService } from '../../services/thesis-report.service';

const cache: {
    data?: IThesisReportSummary
} = {};

export function clearSummaryCache() {
    cache.data = undefined;
}

@Component({
    selector: 'app-thesis-report-summary',
    templateUrl: './summary.component.html'
})
export class ThesisReportSummaryComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: ThesisReportService,
        private activeModal: NgbActiveModal
    ) { }

    data: IThesisReportSummary = { Doctors: [] };

    readonly columns: ITableColumn[] = [
        {
            property: 'FirstName',
            label: 'thesisReport_lblDoctor',
            sorts: true,
            sortFn: (a: IThesisReportSummaryDoctor, b: IThesisReportSummaryDoctor) => {
                return `${a.FirstName} ${a.LastName}`.localeCompare(`${b.FirstName} ${b.LastName}`);
            }
        },
        {
            property: 'Upn',
            label: 'thesisReport_lblUpn',
            sorts: true
        },
        {
            property: 'HasReport',
            label: 'thesisReport_lblHasReport',
            sorts: true,
            type: 'boolean',
            cssClass: 'text-nowrap',
            width: '1px'
        }
    ];

    ngOnInit() {
        if (cache.data) {
            this.data = cache.data;
        } else {
            this.app.addLoading(this.service.getSummary()).subscribe(data => {
                this.data = cache.data = data;
            });
        }
    }

    close() {
        this.activeModal.dismiss();
    }
}
